/* Dulora collection page — closes the facet popover dropdowns on outside
   click (≥1024px the sidebar is converted into a horizontal row of popovers
   by dulora-collection.css; the theme's DetailsDisclosure only toggles on
   summary clicks and would leave panels stuck open).
   Uses event delegation so it survives facet AJAX re-renders and Theme
   Editor section reloads.
   NOTE: close via the details-disclosure element's close() method, never
   summary.click() — a synthetic click bubbles back into this handler and,
   because DetailsDisclosure keeps [open] until its transition ends, two
   closing panels re-close each other in an unbounded cascade (page freeze). */
if (!window.duloraCollectionFiltersInit) {
  window.duloraCollectionFiltersInit = true;

  const closeFilter = (details) => {
    if (details.classList.contains('is-closing')) return; // already animating shut
    const disclosure = details.closest('details-disclosure');
    if (disclosure && typeof disclosure.close === 'function') {
      disclosure.close(); // reuse the theme's close animation
    } else {
      details.open = false;
    }
  };

  /* ≥1024 the popover closes on its opacity transitionend (see
     dulora-collection.css). If that event never arrives (e.g. closed before
     the entry animation painted a frame) DetailsDisclosure would be left
     half-closed — invisible but still [open] — so finish it by hand. */
  const closeTimers = new WeakMap();
  const guardClosing = () => {
    document.querySelectorAll('.facets__filters details.filter.is-closing').forEach((details) => {
      if (closeTimers.has(details)) return;
      closeTimers.set(details, setTimeout(() => {
        closeTimers.delete(details);
        if (!details.classList.contains('is-closing')) return;
        details.classList.remove('is-closing');
        details.open = false;
        const panel = details.querySelector('.disclosure__panel');
        if (panel) panel.removeAttribute('style');
      }, 400));
    });
  };

  document.addEventListener('click', (evt) => {
    if (!evt.isTrusted) return; // ignore programmatic clicks
    if (!window.matchMedia('(min-width: 1024px)').matches) return;

    // composedPath(), not details.contains(evt.target): the path is fixed when
    // the click is dispatched, so it still counts as "inside" when a handler
    // has already removed the target — e.g. facet-filters.js deletes the
    // "Show more" button on click, which used to shut its own dropdown.
    const path = evt.composedPath();
    document.querySelectorAll('.facets__filters details.filter[open]').forEach((details) => {
      if (path.includes(details)) return; // click inside this dropdown
      closeFilter(details);
    });

    // DetailsDisclosure's summary handler has already run (it's bound on the
    // summary; this listener is on document). The popover ignores its inline
    // heights, so drop them rather than leave one behind for the mobile drawer.
    document.querySelectorAll('.facets__filters details.filter[open]:not(.is-closing) > .disclosure__panel[style]')
      .forEach((panel) => panel.removeAttribute('style'));
    guardClosing();
  });

  document.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Escape') return;
    document.querySelectorAll('.facets__filters details.filter[open]').forEach(closeFilter);
    if (window.matchMedia('(min-width: 1024px)').matches) guardClosing();
  });

  // A group swapped in already open by facet-filters.js skips the entry
  // animation; re-arm it once that group closes. (`toggle` doesn't bubble.)
  document.addEventListener('toggle', (evt) => {
    const details = evt.target;
    if (!details.open && details.matches && details.matches('details.filter[data-no-enter]')) {
      delete details.dataset.noEnter;
    }
  }, true);
}
